module.exports = __webpack_public_path__ + "models/house_mobile_e56c3b0a804b2f9d625f23406124454a.glb";